import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

const PILL_WIDTHS = ['w-[45%]', 'w-[65%]', 'w-[80%]', 'w-[55%]', 'w-[70%]', 'w-[60%]'];

export const ChatHistorySkeleton = ({ rows = 5, className }) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading chat history"
      className={cn('flex flex-col gap-3 px-3 py-3 w-full', className)}
    >
      {Array.from({ length: rows }).map((_, i) => {
        const isAi = i % 2 === 0;
        const pillWidth = PILL_WIDTHS[i % PILL_WIDTHS.length];
        return (
          <div
            key={i}
            className={cn(
              'flex items-start gap-2',
              isAi ? 'justify-start' : 'justify-end'
            )}
          >
            {isAi && (
              <Skeleton className="h-7 w-7 min-w-[1.75rem] rounded-full !bg-[#EBEFF6]" />
            )}
            <Skeleton className={cn('h-9 rounded-lg !bg-[#EBEFF6]', pillWidth)} />
            {!isAi && (
              <Skeleton className="h-7 w-7 min-w-[1.75rem] rounded-full !bg-[#EBEFF6]" />
            )}
          </div>
        );
      })}
      <span className="sr-only">Loading chat history</span>
    </div>
  );
};

ChatHistorySkeleton.displayName = 'ChatHistorySkeleton';

export default ChatHistorySkeleton;
